__turbopack_context__.v({
  "card": "OAqN-W_card",
  "iconTile": "OAqN-W_iconTile",
});
